/*=========================================================================================
  File Name: moduleCompanyMutations.js
  Description: Company Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	ADD_RESOURCE_CHECKED(state, item) {
		const itemIndex = state.checkedResources.findIndex((p) => p.id === item.id);
		if (itemIndex === -1) {
			state.checkedResources.push(item);
		}
	},
	DEL_RESOURCE_CHECKED(state, item) {
		const itemIndex = state.checkedResources.findIndex((p) => p.id === item.id);
		if (itemIndex >= 0) {
			state.checkedResources.splice(itemIndex, 1);
		}
	},
	CLEAR_DEL_RESOURCE_CHECKED(state) {
		state.checkedResources = [];
	},
	ADD_RESOURCE(state, resource) {
		state.resources.unshift(resource);
	},
	SET_RESOURCES(state, resources) {
		state.resources = resources;
	},
	SET_AVAILABLE_RESOURCES(state, availableResources) {
		state.availableResources = availableResources;
	},
	SAVE_AVAILABLE_RESOURCES_PAYLOAD(state, data) {
		state.availableResourcesCurrentPayload = data;
	},
	UPDATE_RESOURCE(state, resource) {
		const resourceIndex = state.resources.findIndex((r) => r.id === resource.id);
		if (resourceIndex >= 0) Object.assign(state.resources[resourceIndex], resource);
	},
	REMOVE_RESOURCE(state, itemId) {
		const ItemIndex = state.resources.findIndex((p) => p.id === itemId);
		state.resources.splice(ItemIndex, 1);
	},
	SET_RESOURCES_ACTIVITY(state, resources) {
		state.resourcesActivity = resources;
	},
	ADD_RESOURCE_ACTIVITY(state, resources) {
		let arrayNew = state.resourcesActivity.concat(
			resources.filter((element) => state.resourcesActivity.find((e) => e.id === element.id) === undefined)
		);
		state.resourcesActivity = arrayNew;
	},
	REMOVE_RESOURCE_ACTIVITY(state, itemId) {
		const ItemIndex = state.resourcesActivity.findIndex((p) => p.id === itemId);
		state.resourcesActivity.splice(ItemIndex, 1);
	},
	CLEAN_RESOURCE_ACTIVITY(state) {
		state.resourcesActivity = [];
	},
	UPDATE_PAGINATION(state, pagination) {
		Object.assign(state.pagination, pagination);
	},
	UPDATE_CURRENT_PAGE(state, page) {
		Object.assign(state.dataPage, page);
	},
	UPDATE_MESSAGE_RESOURCE(state, {resource, total_messages}) {
		const resourceIndex = state.resourcesComunication.findIndex((r) => r.id === resource.id);
		if (resourceIndex > 0) {
			Object.assign(state.resourcesComunication[resourceIndex], {...resource, total_messages});
			this.commit("moduleResource/ORDER_DATA");
		}
	},
	ORDER_DATA(state) {
		/** comparar mayor por el atributo date */
		const compare = (a, b) => {
			if (a.total_messages > b.total_messages) {
				return -1;
			}
			if (a.total_messages < b.total_messages) {
				return 1;
			}
			return 0;
		};
		state.resourcesComunication = Array.from(state.resourcesComunication).sort(compare);
	},
	CLEAR_RESOURCES(state) {
		state.resources = [];
	},
	CURRENT_SELECTED_RESOURCE(state, resource) {
		state.currentSelectedResource = resource;
	},
	SET_SELECTED_RESOURCE(state, resource) {
		//const resourceIndex = state.resources.findIndex((r) => r.id === resource.id)
		state.resources = state.resources.map((r) => {
			if (r.id === resource.id) return {...resource, selected: !resource.selected};
			return {...r, selected: false};
		});
		//Object.assign(state.resources[resourceIndex], { ...resource, selected : true })
	},
	ADD_MARKER_RESOURCE(state, resourceMarker) {
		state.markerResources.push(resourceMarker);
	},
	SET_MULTISELECTED_RESOURCE(state, resource) {
		const resourceIndex = state.resources.findIndex((r) => r.id === resource.id);
		state.resources[resourceIndex] = {...state.resources[resourceIndex], selected: !resource.selected};
		state.resources = [...state.resources];
	},
	SET_RESOURCES_COMUNICATION(state, resources) {
		state.resourcesComunication = resources;
	},
	CLEAR_RESOURCES_COMMUNICATION(state) {
		state.resourcesComunication = [];
	},
	SET_SELECTED_RESOURCE_PAGES(state, resources) {
		state.selectedResources = resources;
	},
	REMOVE_RESOURCE_COMMUNICATION(state, resourceId) {
		const ItemIndex = state.resourcesComunication.findIndex((p) => p.id === resourceId);
		state.resourcesComunication.splice(ItemIndex, 1);
	},
};
